import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Brand, brands as fallbackBrands } from "@/data/brands";

export const useBrands = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["brands"],
    enabled: options?.enabled ?? true,
    queryFn: async (): Promise<Brand[]> => {
      const { data, error } = await supabase.functions.invoke("fetch-brands");
      
      if (error) {
        return fallbackBrands;
      }
      
      if (data?.brands && Array.isArray(data.brands) && data.brands.length > 0) {
        return data.brands;
      }
      
      return fallbackBrands;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  });
};
